export const COLOR = {
  RED: '#D32D2F',
  BLACK: '#111111',
  GRAY_100: '#767676',
  GRAY_200: '#CDCDCD',
  GRAY_300: '#EFEFEF',
  WHITE: '#FFFFFF',
};
